module.exports = __webpack_public_path__ + "static/media/DownloadImage.f4603cb5.png";